import {createTooltipTranslationProviderFromNamespace} from 'features/localizedTooltips';
import {VEHICLE_PROJECTS_TRANSLATION_NAMESPACE} from './vehicleProjectConstants';

export const VehicleProjectsTooltipTranslationProvider =
	createTooltipTranslationProviderFromNamespace(
		VEHICLE_PROJECTS_TRANSLATION_NAMESPACE,
	);
